import { Box } from "@chakra-ui/react";

import { Paragraph3 } from "ui/typography";

import { IndividualContentItem } from "./IndividualContentItem";
import { IIndividualContentItem, IndividualDetailsProps } from "./types";

export const EducationAndIncomeDetails = (props: IndividualDetailsProps) => {
  const { isContentWrapperBelow600, isContentWrapperBelow745, individual } =
    props;
  const {
    educationLevel,
    employmentStatus,
    sourceOfIncome,
    workIndustry,
    employmentLevel,
    monthlySalaryRange,
  } = individual.employmentDetails || {};

  const userDetails: IIndividualContentItem[] = [
    {
      title: "Education Level",
      content: educationLevel || "N/A",
    },
    {
      title: "Employment Status",
      content: employmentStatus || "N/A",
    },
    {
      title: "Sources of Income",
      content: sourceOfIncome || "N/A",
    },
    {
      title: "Work Industry",
      content: workIndustry || "N/A",
    },
    {
      title: "Employment Level",
      content: employmentLevel || "N/A",
    },
    {
      title: "Monthly Salary Range",
      content: monthlySalaryRange || "N/A",
    },
  ];

  return individual.id ? (
    <>
      <Box className="flex flex-col gap-6">
        <Box>
          <Box
            css={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: "32px",
              rowGap: "16px",
            }}
          >
            {userDetails.map((verificatioResult, index) => (
              <IndividualContentItem
                key={index}
                title={verificatioResult.title}
                content={verificatioResult.content}
                isContentWrapperBelow745={isContentWrapperBelow745}
                isContentWrapperBelow600={isContentWrapperBelow600}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  ) : (
    <Box>
      <Paragraph3
        lineHeight="22.4px"
        textColor="#718096"
      >
        Nothing to see here yet.
      </Paragraph3>
    </Box>
  );
};
